import { render, staticRenderFns } from "./item-info.vue?vue&type=template&id=88bc624e&scoped=true"
import script from "./item-info.vue?vue&type=script&lang=js"
export * from "./item-info.vue?vue&type=script&lang=js"
import style0 from "./item-info.vue?vue&type=style&index=0&id=88bc624e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88bc624e",
  null
  
)

export default component.exports